// extracted by mini-css-extract-plugin
export default {"skeleton":"PlanGroupCardSkeleton_skeleton__e3dpr","shimmer":"PlanGroupCardSkeleton_shimmer__kvfKp"};